import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../endPoints/endPoints";
import { IOptionType } from "../interfaces/IlandCategory";
import { IRouteResponse } from "../interfaces/IRoutes";


export const routesApi = createApi({
  reducerPath: "routes",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.AIRROUTES,
  }),
  tagTypes: ["routes"],
  endpoints: (builder) => ({
    getAirRoutesOptions: builder.query<IOptionType[], void>({
      query() {
        return {
          url: ``,
          method: "GET",
          credentials: "include",
        };
      },
      transformResponse: (resp: IRouteResponse) => {
        return resp.data.map(item => ({
            id: item.id,
            title: `${item.name}, взлет: ${item.takeoff}`
        }))
      },
      providesTags: ["routes"],
    }),
  }),
});

export const { useGetAirRoutesOptionsQuery } = routesApi;